import { Component, OnInit } from '@angular/core';
/* note: from post sprint 8 merge
import * as MiniIBEActions from '@ibe/store/actions/mini-ibe.actions';
import * as BookingStepsActions from '@ibe/store/actions/booking-steps.actions';
import { Router } from '@angular/router';
import { ModalService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../../store';
import { NavigateAwayModalComponent } from '@ibe.components/shared/navigate-away-modal/navigate-away-modal.component';
import { BookingStep } from '@ibe/models/ui';
import { Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
*/

@Component({
  selector: 'app-footer-fallback',
  templateUrl: './footer-fallback.indra.component.html',
  styleUrls: ['./footer-fallback.component.scss']
})
export class INDRAFooterFallbackComponent implements OnInit {
	/* note: from post sprint 8 merge
	htmlElement = document.getElementsByTagName('html');
	
	private isAlive = true;

	bookingSteps: Array<BookingStep> = [];
	booking_steps$: Observable<Array<BookingStep>> = this.store.select(
		fromStore.getSelectedBookingSteps
	);
	isCorporate$: Observable<boolean> = this.store.select(fromStore.getIsCorporate);
	*/

	constructor( /* private router: Router, private modalService: ModalService, private store: Store<fromStore.State> */) { 
		/* note: from post sprint 8 merge
		this.booking_steps$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => this.bookingSteps = value);
		*/
	}

	ngOnInit() {
	}

	openNewTab(url) {
		window.open(url);
	}
	
	/* note: from post sprint 8 merge
	TAP_handleClose() {
		// Enable scroll on body mobile again
		this.htmlElement[0].classList.remove('no-scroll-mobile');
	}

	TAP_handleItemClick() {
		this.TAP_handleClose();
		const activeBooking = this.bookingSteps.length > 0;
		if (activeBooking) {
			this.modalService.assignComponent(NavigateAwayModalComponent);
			this.modalService.open();

			this.modalService.navigateAwaySelection$.subscribe(value => {
				if (value) {
					this.store.dispatch(new MiniIBEActions.Reset());
					this.router.navigate(['/corporate']);
					this.store.dispatch(new BookingStepsActions.ResetAction());
				}
			});
		} else {
			this.store.dispatch(new MiniIBEActions.Reset());
			this.router.navigate(['/corporate']);
		}
	}
	*/
}
